export default __webpack_public_path__ + "static/media/discover-single.4a41ea44.svg";